export enum PaidAccountErrorExtensions {
  // server/app/helper/billing/errors.js
  BILLING_UNCONFIRMED = 'BILLING_UNCONFIRMED',
  BILLING_ACCOUNT_ALREADY_EXISTS = 'BILLING_ACCOUNT_ALREADY_EXISTS',
  BILLING_ACCOUNT_NOT_CANCELLED = 'BILLING_ACCOUNT_NOT_CANCELLED',
  BILLING_ACCOUNT_NOT_FOUND = 'BILLING_ACCOUNT_NOT_FOUND',
  BILLING_FREE_TRIAL_NOT_APPLICABLE = 'BILLING_FREE_TRIAL_NOT_APPLICABLE',
  BILLING_INVALID_PRODUCT = 'BILLING_INVALID_PRODUCT',
  BILLING_INVALID_NAME = 'BILLING_INVALID_NAME',
  BILLING_INVALID_EMAIL = 'BILLING_INVALID_EMAIL',
  BILLING_INVALID_TOS = 'BILLING_INVALID_TOS',
  BILLING_INVALID_CARD_NUMBER = 'BILLING_INVALID_CARD_NUMBER',
  BILLING_INVALID_COUNTRY = 'BILLING_INVALID_COUNTRY',
  BILLING_INVALID_ZIP_CODE = 'BILLING_INVALID_ZIP_CODE',
  BILLING_INVALID_TAX_ID = 'BILLING_INVALID_TAX_ID',
  BILLING_INVALID_BILLING_PERIOD = 'BILLING_INVALID_BILLING_PERIOD',
  BILLING_UNSUPPORTED_CARD_TYPE = 'BILLING_UNSUPPORTED_CARD_TYPE',
  BILLING_CARD_DECLINED = 'BILLING_CARD_DECLINED',
  BILLING_SERVICE_UNAVAILABLE = 'BILLING_SERVICE_UNAVAILABLE',
}

export const PaidAccountErrors: Record<string, PaidAccountErrorExtensions> = {
  'already has a paid account':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_ALREADY_EXISTS,
  'already has an account':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_ALREADY_EXISTS,
  'account is not cancelled':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_NOT_CANCELLED,
  'does not have a paid account':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_NOT_FOUND,
  'does not have an account':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_NOT_FOUND,
  'tried to add free trial without account':
    PaidAccountErrorExtensions.BILLING_ACCOUNT_NOT_FOUND,
  'outdated product': PaidAccountErrorExtensions.BILLING_INVALID_PRODUCT,
  "can't switch away from a prebilled product":
    PaidAccountErrorExtensions.BILLING_INVALID_PRODUCT,
  'You can only have one product at a time':
    PaidAccountErrorExtensions.BILLING_INVALID_PRODUCT,
  'need to provide productId':
    PaidAccountErrorExtensions.BILLING_INVALID_PRODUCT,
  'invalid email address': PaidAccountErrorExtensions.BILLING_INVALID_EMAIL,
  'invalid value for country':
    PaidAccountErrorExtensions.BILLING_INVALID_COUNTRY,
  'invalid value for zipCode':
    PaidAccountErrorExtensions.BILLING_INVALID_ZIP_CODE,
  'invalid value for taxId': PaidAccountErrorExtensions.BILLING_INVALID_TAX_ID,
  'invalid value for billingContactFullName':
    PaidAccountErrorExtensions.BILLING_INVALID_NAME,
  'invalid value for billingContactEmail':
    PaidAccountErrorExtensions.BILLING_INVALID_EMAIL,
  'invalid value for acceptTOS': PaidAccountErrorExtensions.BILLING_INVALID_TOS,
  'U.S. addresses require a 5 or 9 digit zip code. Canadian addresses require a Postal Code.':
    PaidAccountErrorExtensions.BILLING_INVALID_ZIP_CODE,
  'already used free trial':
    PaidAccountErrorExtensions.BILLING_FREE_TRIAL_NOT_APPLICABLE,
  'Cannot redeem free trial on this team':
    PaidAccountErrorExtensions.BILLING_FREE_TRIAL_NOT_APPLICABLE,
  'must accept terms of service':
    PaidAccountErrorExtensions.BILLING_INVALID_TOS,
  'needs a credit card nonce':
    PaidAccountErrorExtensions.BILLING_INVALID_CARD_NUMBER,
  'invalid value for credit card number':
    PaidAccountErrorExtensions.BILLING_INVALID_CARD_NUMBER,
  'invalid value for cardNumber':
    PaidAccountErrorExtensions.BILLING_INVALID_CARD_NUMBER,
  'need to verify account': PaidAccountErrorExtensions.BILLING_UNCONFIRMED,
  'card was declined': PaidAccountErrorExtensions.BILLING_CARD_DECLINED,
  'The card was declined. Please use a different card or contact your bank.':
    PaidAccountErrorExtensions.BILLING_CARD_DECLINED,
  'Trello could not contact its payment service to complete the transaction.':
    PaidAccountErrorExtensions.BILLING_SERVICE_UNAVAILABLE,
};
